
export default {
  methods: {
    scrollTo(page, currentRefinement) {
      if (page !== currentRefinement) {
        this.$emit('scroll-to')
      }
    },

    // pagesAmount(pages, currentRefinement) {
    //   if (pages <= 5) {
    //     return pages
    //   }
    //   let start = currentRefinement - 2
    //   let end = currentRefinement + 2

    //   if (start < 0) {
    //     start = 0
    //     end = 4
    //   }
    //   console.log(pages.length)
    //   if (end > pages.length - 1) {
    //     end = pages.length - 1
    //     start = pages.length - 5
    //   }
    //   console.log(pages)
    //   const cropedPageArray = pages.slice(start, end)
    //   console.log(cropedPageArray)
    //   return cropedPageArray
    // },
  },
}
